module.exports = __webpack_public_path__ + "images/HaulerW365.f8a0cc7dc0b46b46a5e4ecf79d1af24d.png";